import React, { useCallback, useEffect, useMemo, useState } from 'react'
import {
    DataGrid,
    GridColDef,
    GridActionsCellItem,
    GridRowId,
    GridRowParams,
    esES,
    GridValueGetterParams,
} from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import { LevelHandler } from './LevelHandler';

const LevelTable = (props: ILevelTableProps) => {
    const { data: rows, onChange } = props;
    const [open, setOpen] = useState(false);
    const [rowIdSelected, setRowIdSelected] = useState<GridRowId | undefined>(undefined);

    const itemSelected = useMemo(() => {
        const item = rows.find(item => item.id === rowIdSelected);
        if (item !== undefined) return item;
    }, [rowIdSelected, rows]);

    const editLevel = useCallback(
        (id: GridRowId) => () => {
            const item = rows.find(item => item.id === id);
            if (item === undefined) return;

            setOpen(true);
            setRowIdSelected(item.id);
        },
        [rows],
    );


    const columns: GridColDef[] = useMemo(() => [
        {
            field: 'title',
            headerName: 'Nivel',
            width: 200,
            sortable: false,
            editable: false,
            valueGetter: (params: GridValueGetterParams<ILevel>) => {
                return params.row.name;
            },
        },
        {
            field: 'activation',
            headerName: 'Duración',
            width: 150,
            sortable: false,
            editable: false,
            valueGetter: (params: GridValueGetterParams<ILevel>) => {
                let raw = params.row.activation;
                let option: TLevelHandlerOption = 'No activar';

                if (raw === undefined) option = 'No activar';
                else if (raw === 'UNLIMITED') option = 'Por siempre';
                else {
                    if (raw === 30) option = '1 mes';
                    else if (raw === 60) option = '2 meses';
                    else if (raw === 90) option = '3 meses';
                    else if (raw === 120) option = '4 meses';
                    else if (raw === 150) option = '5 meses';
                    else if (raw === 180) option = '6 meses';
                }

                return option;
            },
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Opciones',
            width: 100,
            sortable: false,
            editable: false,
            getActions: (params: GridRowParams) => [
                <GridActionsCellItem icon={<EditIcon />} label="Editar" onClick={editLevel(params.id)} />,
            ]
        },
    ], [editLevel]);

    return (
        <>
            <DataGrid
                localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                autoHeight
                rowSelection={false}
                columns={columns}
                rows={rows}
            />
            <LevelHandler
                open={open}
                payload={itemSelected}
                onSubmit={(payload) => {
                    const _rows = [...rows];
                    const index = _rows.findIndex(item => item.id === payload.id);
                    if (index !== -1) _rows[index] = payload;
                    else _rows.push(payload);

                    onChange(_rows);
                }}
                onClose={() => {
                    setOpen(false);
                    setRowIdSelected(undefined);
                }}
            />
        </>
    );

};

export interface Episode {
    episodeId: string;
    title: string;
    activation: undefined | number | 'UNLIMITED';
}

export { LevelTable };